import { createI18n } from 'vue-i18n'

const messages = {
    'zh': require('./lang/zh.json'),
    'en':require('./lang/en.json')
}

const i18n = createI18n({
    legacy: false, // Vue3 必须设置为 false
    locale: 'zh', // 默认语言
    fallbackLocale: 'en', // 回退语言
    messages
})

export default i18n
